import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { User, Mail, Phone, Building2, ArrowRight, Loader2 } from "lucide-react";
import { sendRegisterRequest } from "../../api/auth";
import AuthShell, {
  authInputWithIconClass,
  authPrimaryBtnClass,
} from "./AuthShell";

export default function RegisterPage() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    otherInfo: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone) {
      toast.error("Vui lòng nhập đầy đủ thông tin bắt buộc");
      return;
    }

    setIsSubmitting(true);
    try {
      await sendRegisterRequest({
        name: form.name,
        email: form.email,
        phone: form.phone,
        branch: form.otherInfo,
      });
      toast.success("Đã gửi thông tin đăng ký. Chúc bạn một ngày tốt lành!");
      navigate("/login");
    } catch (err) {
      toast.error("Lỗi khi gửi đăng ký");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Đăng ký"
      title="Yêu cầu tài khoản mới"
      subtitle="Điền thông tin để gửi yêu cầu mở tài khoản IMA ERP. Quản trị viên sẽ liên hệ xác nhận."
      brandDescription="Gửi yêu cầu một lần — đội ngũ quản trị sẽ cấp quyền truy cập phù hợp với vai trò và chi nhánh của bạn."
      maxWidthClass="max-w-[440px]"
      footer={
        <p className="text-center text-sm text-stone-500">
          Đã có tài khoản?{" "}
          <Link to="/login" className="font-semibold text-[#8f1219] hover:underline">
            Đăng nhập
          </Link>
        </p>
      }
    >
      <form className="space-y-4" onSubmit={handleSubmit}>
        <div className="flex flex-col gap-1.5">
          <label className="text-sm font-semibold text-stone-700">
            Họ và tên <span className="text-[#8f1219]">*</span>
          </label>
          <div className="relative">
            <User
              className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-stone-400"
              size={17}
            />
            <input
              type="text"
              name="name"
              placeholder="Nguyễn Văn A"
              className={authInputWithIconClass}
              value={form.name}
              onChange={handleChange}
              disabled={isSubmitting}
            />
          </div>
        </div>

        <div className="flex flex-col gap-1.5">
          <label className="text-sm font-semibold text-stone-700">
            Email <span className="text-[#8f1219]">*</span>
          </label>
          <div className="relative">
            <Mail
              className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-stone-400"
              size={17}
            />
            <input
              type="email"
              name="email"
              placeholder="name@example.com"
              className={authInputWithIconClass}
              value={form.email}
              onChange={handleChange}
              disabled={isSubmitting}
            />
          </div>
        </div>

        <div className="flex flex-col gap-1.5">
          <label className="text-sm font-semibold text-stone-700">
            Số điện thoại <span className="text-[#8f1219]">*</span>
          </label>
          <div className="relative">
            <Phone
              className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-stone-400"
              size={17}
            />
            <input
              type="tel"
              name="phone"
              placeholder="09xx xxx xxx"
              className={authInputWithIconClass}
              value={form.phone}
              onChange={handleChange}
              disabled={isSubmitting}
            />
          </div>
        </div>

        <div className="flex flex-col gap-1.5">
          <label className="text-sm font-semibold text-stone-700">
            Thông tin khác <span className="font-normal text-stone-400">(tuỳ chọn)</span>
          </label>
          <div className="relative">
            <Building2
              className="pointer-events-none absolute left-3.5 top-3.5 text-stone-400"
              size={17}
            />
            <textarea
              name="otherInfo"
              rows={3}
              placeholder="Chi nhánh, vị trí công tác hoặc ghi chú thêm..."
              className={`${authInputWithIconClass} resize-none py-3`}
              value={form.otherInfo}
              onChange={handleChange}
              disabled={isSubmitting}
            />
          </div>
        </div>

        <button type="submit" disabled={isSubmitting} className={authPrimaryBtnClass}>
          {isSubmitting ? (
            <>
              <Loader2 size={18} className="animate-spin" />
              Đang gửi...
            </>
          ) : (
            <>
              Gửi yêu cầu đăng ký
              <ArrowRight size={17} className="transition group-hover:translate-x-0.5" />
            </>
          )}
        </button>
      </form>
    </AuthShell>
  );
}
